import cx from "classnames";
import useGlobalModal from "components/GlobalModals/GlobalModalContext/useGlobalModal";
import UpgradePlanBanner from "components/UpgradePlan/UpgradePlanBanner";
import useUserPermissions from "config/UserPermissionsContext/useUserPermissions";
import useDefaultBusinessRoute from "hooks/useDefaultBusinessRoute";
import { useNavigate } from "react-router-dom";
import LowImageWarning from "./LowImageWarning";
import MobileHeader from "./MobileHeader";
import useHeaderData from "./useHeaderData";
import useHeaderSideEffects from "./useHeaderSideEffects";

const Header = ({ hideOnLargeScreen }: { hideOnLargeScreen?: boolean }) => {
  const defaultBusinessRoute = useDefaultBusinessRoute();
  const { hasPermission, hasSomePermissions } = useUserPermissions();
  const canReadBusiness = hasPermission("business_details_read");
  const canViewSocialsPage = hasSomePermissions([
    "posting_schedule_write",
    "socials_write",
  ]);
  const { openGlobalModal } = useGlobalModal();
  const navigate = useNavigate();

  const { pathname, scheduled, user, currentBusiness } = useHeaderData();

  useHeaderSideEffects({
    pathname,
    currentBusiness,
    scheduled,
    user,
    canViewSocialsPage,
    canReadBusiness,
    openGlobalModal,
    navigate,
    defaultBusinessRoute,
  });

  return (
    <div
      className={cx(
        "header [grid-area:header] flex flex-col overflow-x-auto !bg-transparent",
        {
          "!border-none": hideOnLargeScreen,
        }
      )}
    >
      <MobileHeader />
      {pathname !== "/dashboard" && currentBusiness?.id && <LowImageWarning />}
      <UpgradePlanBanner />
    </div>
  );
};

export default Header;
